import React, { Component, Fragment } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import PromotionListView from './ListView'
import PromotionDetailView from './DetailView'
import PromotionUpdateView from './UpdateView'
import PromotionEditView from './EditView'

import './styles.scss'

class AuthRoute extends Component {

	isAllowed(claims, name) {
		let permissions = claims;
		let str = `${name && name.toLowerCase()}`;
		let isEnabled = permissions && permissions.includes(str);
        console.log("name",str);
		if (isEnabled) {
			return true
		}
		return false;
	}

	render() {
		const { component: Component, name, claims, clientKey,...rest } = this.props;
		let isAccessable = this.isAllowed(claims, name);
		return (
			<Route exact={true} {...rest} render={(props) => (
				(isAccessable === true) ?
					<Fragment>
						<Component {...props} clientKey={clientKey} />
					</Fragment>
					: null
			)} />
		)
	}
}

class Promotion extends Component {
	render() {
		const { claims, clientKey } = this.props;

		return (
			<Fragment>
				<Switch>
					<AuthRoute exact path='/:clientKey/promotion' component={PromotionListView} clientKey={clientKey} name={"promotion_view"} claims={claims} />
					<AuthRoute exact path='/:clientKey/promotion/:promotionId' component={PromotionUpdateView} clientKey={clientKey} name="promotion_create" claims={claims} />
				</Switch>
			</Fragment>
		)
	}
}

export default Promotion